import { render, staticRenderFns } from "./PaymentTags.vue?vue&type=template&id=541a07b5&scoped=true"
import script from "./PaymentTags.vue?vue&type=script&lang=js"
export * from "./PaymentTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541a07b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541a07b5')) {
      api.createRecord('541a07b5', component.options)
    } else {
      api.reload('541a07b5', component.options)
    }
    module.hot.accept("./PaymentTags.vue?vue&type=template&id=541a07b5&scoped=true", function () {
      api.rerender('541a07b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/PaymentTags.vue"
export default component.exports